import * as React from 'react';
import { SearchCategory, ISearchResultItem } from '../../../Model/core';
import { PageResult } from './page';
import { ArticleResult } from './article';
import { EventResult } from './event';

export const mapping = {
    [SearchCategory.Page]: { component: PageResult },
    [SearchCategory.Product]: { component: ArticleResult },
    [SearchCategory.Event]: { component: EventResult },
};

export interface IndexTypeProps {
    result: ISearchResultItem[];
    more: (cat: SearchCategory) => void;
}

interface Props {
    title: string;
    cls?: string;
    items?: ISearchResultItem[];
    itemsPerPage: number;
    category: SearchCategory;
    showMore: (cat: SearchCategory) => void;
}

interface State {
}

export class ResultSection extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    render() {
        const { props } = this;
        let cls = 'search-result-section';

        if (props.cls) {
            cls += ' ' + props.cls;
        }

        const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
            const elm = e.target as HTMLDivElement;

            if ((elm.scrollHeight - elm.scrollTop) <= elm.clientHeight + (elm.clientHeight / 3)) {
                props.showMore(props.category);
            }
        };

        return (
            <div className={cls} onScroll={handleScroll}>
                <div className='search-result-section-title'>{props.title}</div>

                <div className='search-result-wrapper'>
                    {(!props.items || !props.items.length) &&
                        <div className='no-search-result'>Inga {props.title.toLowerCase()} kunde hittas</div>}

                    {props.children}
                </div>
            </div>
        );
    }
}
